export default "__VITE_ASSET__CnHOOAY6__"